import { match } from 'ts-pattern'
import * as v from 'valibot'
import { I18nStringPairsSchema } from 'src/i18n/localizedContent'
import {
  CampaignMediaType,
  DecorationType,
} from 'src/services/apollo/generated/graphql'

export const imageTypes = ['small', 'medium', 'large'] as const

const mediaAssetObjectSchema = v.strictObject({
  original: v.string(),
  variants: v.optional(
    v.record(
      v.picklist(imageTypes),
      v.strictObject({
        url: v.string(),
        width: v.pipe(v.number(), v.integer(), v.minValue(0)),
        height: v.pipe(v.number(), v.integer(), v.minValue(0)),
      }),
    ),
  ),
})

const DecorationNameSchema = v.strictObject({
  name: I18nStringPairsSchema,
})

/** Badge */
export const DecorationBadgeDataSchema = v.looseObject({
  ...DecorationNameSchema.entries,

  /** Old assetUrl. Keeping for compatibility. */
  assetUrl: v.string(),
  /** Media Asset Composite Object  */
  mediaAsset: v.optional(mediaAssetObjectSchema),
})
/** Avatar Frame - Same as badge */
export const DecorationAvatarFrameDataSchema = DecorationBadgeDataSchema
/** Artwork Frame */
export const DecorationArtworkFrameDataSchema = v.looseObject({
  ...DecorationNameSchema.entries,
  // TODO: make discriminated union
  linearGradient: v.optional(
    v.strictObject({
      degree: v.pipe(v.number(), v.integer(), v.minValue(0), v.maxValue(360)),
      colorStops: v.array(
        v.strictObject({
          colorType: v.picklist(['RRGGBB', 'RRGGBBAA']),
          colorValue: v.string(),
          position: v.pipe(
            v.number(),
            v.integer(),
            v.minValue(0),
            v.maxValue(100),
          ),
        }),
      ),
    }),
  ),
  // conicGradient: TODO
})
export const DecorationLiveBannerDataSchema = v.looseObject({
  ...DecorationNameSchema.entries,

  /** Follows ad campaign media */
  mediaType: v.union([v.literal(CampaignMediaType.VideoHls)]),
  mediaSpec: v.string(),
  previewMediaAsset: mediaAssetObjectSchema,
})

export function getDecorationDataSchema(type: DecorationType) {
  return match(type)
    .with(DecorationType.Badge, () => DecorationBadgeDataSchema)
    .with(DecorationType.AvatarFrame, () => DecorationAvatarFrameDataSchema)
    .with(DecorationType.ArtworkFrame, () => DecorationArtworkFrameDataSchema)
    .with(DecorationType.LiveBanner, () => DecorationLiveBannerDataSchema)
    .otherwise(() => null)
}
